module.exports = __webpack_public_path__ + "img/1.2577467b.png";